<template>
<div style="height: 500px">
  <div class="center-list">
    <div class="title-top">
      <div class="title-edit">
        <span>{{devicePerson.name}}</span>
<!--        <i class="el-icon-edit-outline"></i>-->
      </div>
<!--      <div class="user-add-right">-->
<!--        <img style="width: 28px" src="../../../assets/tel/addUser.png">-->
<!--      </div>-->
    </div>
    <div class="window-center" @scroll="scrollInfo()" ref="msgBox">
      <div ref="msgData">
        <div v-for="(item, index) in  devicemsgs" :key="item.index">
        <!-- 设备 左边 -->
        <div v-if="item.msg_type === 0" class="chat-item">
          <div class="img-left">
            <el-avatar style="width: 50px;height: 50px" :src="devicePerson.photourl !== '' ? devicePerson.photourl : 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png'"></el-avatar>
          </div>
          <div class="voice-right" @click="playRecordItem(item, index,item.isRecordType)">
            <div style="width: calc(100% - 20px)" class="left-voice-content">
              <img v-if="item.isGif" style="width: 14px" src="../../../assets/tel/voice_left_gif.gif">
              <img v-else style="width: 14px" src="../../../assets/tel/voice_left.png">
              <audio :src="base + item.msg_url" :ref="'mp3Item'+index" />
            </div>
            <!--          <div class="no-read" style="float: left;margin-left: 3px"></div>-->
          </div>
        </div>
        <!-- 平台 右边 -->
        <div v-else class="chat-item">
          <div class="img-left1">
            <el-avatar style="width: 50px;height: 50px" src="https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png"></el-avatar>
          </div>
          <div class="voice-right1" @click="playRecordItem(item, index,item.isRecordType)">
            <div style="width: calc(100% - 20px)" class="right-voice-content">
              <audio :src="base + item.msg_url" :ref="'mp3Item'+index" />
              <img v-if="item.isGif" style="width: 14px" src="../../../assets/tel/voice_right_gif.gif">
              <img v-else style="width: 14px" src="../../../assets/tel/voice_right.png">
            </div>
<!--            <div class="no-read" style="float: right;margin-right: 3px"></div>-->
          </div>
        </div>
          <div style="height: 20px">
            <div class="time-show" v-if="item.msg_type === 0" style="margin-left: 80px;margin-top: -5px"><span>{{ item.msg_tm }}</span></div>
            <div class="time-show" v-else style="margin-right: 80px;float: right;margin-top: -5px"><span>{{ item.msg_tm }}</span></div>
          </div>
      </div>
      </div>
    </div>
    <div class="msg-send">
      <div class="area-text">
        <input style="width: 100%;" class="input" placeholder="请在此输入文字" v-model="sendWord"/>
      </div>
      <div class="send-btn-chat" @click="sendVoiceMsg()"><span>转语音发送</span></div>
    </div>
  </div>
  <div class="right-msg">
    <div class="head-portrait-top">
      <el-avatar style="width: 130px;height: 130px" :src="devicePerson.photourl !== '' ? devicePerson.photourl : 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png'"></el-avatar>
    </div>
    <div class="msg-list">
      <el-row>
        <el-col :span="4" style="text-align: right"><img src="../../../assets/tel/person.png"> </el-col>
        <el-col :span="20">
          <div class="right-text"><span>&nbsp;&nbsp;{{devicePerson.name}}</span></div>
        </el-col>
      </el-row>
    </div>
    <div class="msg-list">
      <el-row>
        <el-col :span="4" style="text-align: right"><img src="../../../assets/tel/address.png"> </el-col>
        <el-col :span="20">
          <div class="right-text"><span>&nbsp;&nbsp;{{ devicePerson.h_address }}</span></div>
        </el-col>
      </el-row>
    </div>
    <div class="msg-list">
      <el-row>
        <el-col :span="4" style="text-align: right"><img src="../../../assets/tel/device.png"> </el-col>
        <el-col :span="20">
          <div class="right-text"><span>&nbsp;&nbsp;{{ chatObj.deviceRow.deviceid ? chatObj.deviceRow.deviceid : '' }}</span></div>
        </el-col>
      </el-row>
    </div>
    <div class="msg-list">
      <el-row>
        <el-col :span="4" style="text-align: right"><img src="../../../assets/tel/phone.png"> </el-col>
        <el-col :span="20">
          <div class="right-text"><span>&nbsp;&nbsp;13885858888</span></div>
        </el-col>
      </el-row>
    </div>
  </div>
</div>
</template>

<script>
import {querydevicemsg, querypersonbydid, queryorgpersonbyuid, adddevicemsg} from '../../../api/device'
import BenzAMRRecorder from 'benz-amr-recorder'

export default {
  name: 'chatDevice',
  model: {
    prop: 'chatOpen',
    event: 'change'
  },
  props: {
    chatObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      searchWord: '',
      sendWord: '',
      pageSize: 10,
      currentPage: 1,
      totalCells: 0,
      devicemsgs: [],
      devicePerson: '',
      orgpersons: '',
      amr: null,
      lastAudio: null,
      base: '',
      hasMore: true
    }
  },
  created () {
    this.getPersonByDidData()
    this.getDeviceVoiceMsg()
    this.base = window.location.protocol + '//' + window.location.host
    if (window.location.host.split(':')[0] === 'localhost') {
      this.base = 'https://jiaold.com/'
    }
  },
  methods: {
    // mqtt
    getMattData (obj) {
      console.log('刷新', obj, this.chatObj.deviceRow.deviceid)
      if (obj.device_id !== this.chatObj.deviceRow.deviceid) {
        return
      }
      this.pageSize = 10
      this.currentPage = 1
      this.totalCells = 0
      this.devicemsgs = []
      this.getDeviceVoiceMsg()
    },
    scrollInfo (e) {
      if (!this.$refs.msgBox.scrollTop) {
        if (!this.hasMore) {
          return
        }
        this.currentPage++
        this.getDeviceVoiceMsg()
      }
    },
    // 设备id获取人员信息
    getPersonByDidData () {
      if (this.chatObj.deviceRow === '') {
        return
      }
      let data = {
        did: this.chatObj.deviceRow.id
      }
      querypersonbydid(data).then(res => {
        this.devicePerson = res.data.person[0] ? res.data.person[0] : ''
      }).catch(() => {})
    },
    // 使用账号ID获取平台人员信息
    getPersonByUidData (uid) {
      if (this.chatObj.deviceRow === '' || uid === 0) {
        return
      }
      let data = {
        uid: uid
      }
      queryorgpersonbyuid(data).then(res => {
        this.orgpersons = res.data.orgpersons[0] ? res.data.orgpersons[0] : ''
      }).catch(() => {})
    },
    getDeviceVoiceMsg () {
      if (this.chatObj.deviceRow === '') {
        return
      }
      let params = {
        page: this.currentPage,
        size: this.pageSize
      }
      let data = {
        did: parseInt(this.chatObj.deviceRow.id)
      }
      // console.log(params)
      querydevicemsg(params, data).then(res => {
        let arr = []
        for (let i = 0; i < res.data.devicemsgs.length; i++) {
          arr.unshift(res.data.devicemsgs[i])
        }
        this.devicemsgs = arr.concat(this.devicemsgs)
        if (res.data.cnt <= this.devicemsgs.length) {
          this.hasMore = false
        }
        this.devicemsgs.forEach(function (record) {
          if (record.msg_url.substring(record.msg_url.length - 3, record.msg_url.length) === 'amr') {
            record['isRecordType'] = 'amr'
          } else {
            record['isRecordType'] = 'mp3'
          }
          record['isRecord'] = false
          record['isGif'] = false
        })
        this.totalCells = res.data.cnt
        if (this.devicemsgs.length > 0 && this.orgpersons === '') {
          this.getPersonByUidData(this.devicemsgs[0].uid)
        }
        this.$nextTick(() => {
          if (this.currentPage === 1) {
            this.scrollToEnd(this.$refs.msgBox, this.$refs.msgData)
          }
        })
      }).catch(() => {})
    },
    playRecordItem (item, index, type) {
      // console.log(item, index, type)
      if (type === 'mp3') {
        if (this.amr !== null) {
          if (this.amr.isPlaying()) {
            this.amr.stop()
          }
          this.amr = null
          this.devicemsgs.forEach(function (record) {
            record.isRecord = false
            record.isGif = false
          })
          this.$forceUpdate()
        }
        if (this.lastAudio) {
          this.lastAudio.pause()
          this.lastAudio.currentTime = 0
          this.devicemsgs.forEach(function (record) {
            record.isRecord = false
            record.isGif = false
          })
          this.$forceUpdate()
        }

        this.devicemsgs[index].isGif = true
        this.$forceUpdate()
        this.lastAudio = this.$refs['mp3Item' + index][0]
        this.$refs['mp3Item' + index][0].play()
        let vm = this
        this.$refs['mp3Item' + index][0].addEventListener('ended', (e) => {
          vm.devicemsgs[index].isGif = false
          this.$forceUpdate()
        })
      } else { // arm
        if (!item.isRecord) {
          this.playRecord(item, index)
        } else {
          this.stopRecord(item, index)
        }
      }
      //  @click="!item.isRecord ? playRecord(item) : stopRecord(item)"
    },
    playRecord (row, index) {
      // console.log(row.msg_url.substring(row.msg_url.length - 3, row.msg_url.length))
      let vm = this
      let flag = false
      if (row.msg_url.substring(row.msg_url.length - 3, row.msg_url.length) === 'amr') {
        flag = true
      }
      if (flag) {
        if (this.lastAudio) {
          this.lastAudio.pause()
          this.lastAudio.currentTime = 0
          this.devicemsgs.forEach(function (record) {
            record.isRecord = false
            record.isGif = false
          })
          this.$forceUpdate()
        }
        if (vm.amr !== null) {
          if (vm.amr.isPlaying()) {
            vm.amr.stop()
          }
          vm.amr = null
          this.devicemsgs.forEach(function (record) {
            record.isRecord = false
            record.isGif = false
          })
          this.$forceUpdate()
        }
        vm.amr = new BenzAMRRecorder()
        let url = this.base + row.msg_url
        // let url = "https://jiajiafile.jiajialife.com:20087/audio/353537067400568_1666087242.amr",
        vm.amr.initWithUrl(url).then(function () {
          vm.amr.play()
          vm.devicemsgs[index].isRecord = true
          vm.devicemsgs[index].isGif = true
          // vm.devicemsgs.forEach(function (record) {
          //   if (record.id !== row.id) {
          //     record.isRecord = true
          //     record.isGif = true
          //   }
          // })
          vm.$forceUpdate()
        })
        vm.amr.onEnded(function () {
          // row.isRecord = false
          vm.devicemsgs.forEach(function (record) {
            record.isRecord = false
            record.isGif = false
          })
          vm.$forceUpdate()
        })
      }
    },
    stopRecord (row, index) {
      if (this.amr !== null) {
        this.amr.stop()
        this.amr = null
        this.devicemsgs[index].isRecord = true
        this.devicemsgs[index].isGif = true
        // row.isRecord = false
        // this.devicemsgs.forEach(function (record) {
        //   record.isRecord = false
        //   record.isGif = false
        // })
        this.$forceUpdate()
      }
    },
    sendVoiceMsg () {
      if (this.chatObj.deviceRow === '') {
        return
      }
      if (this.sendWord !== '') {
        let data = {
          did: this.chatObj.deviceRow.id,
          imei: this.chatObj.deviceRow.deviceid,
          text: this.sendWord,
          device_type: this.chatObj.deviceRow.devicetype
        }
        adddevicemsg(data).then(res => {
          this.getDeviceVoiceMsg()
          this.sendWord = ''
        }).catch(() => {})
      }
    },
    scrollToEnd (el, el1) {
      // console.log(el1.offsetHeight)
      el.scrollTo(0, el1.offsetHeight)
    }
  }
}
</script>

<style scoped>
.input{
  border: none;
  outline: none;
  height: 100%;
  font-size: 18px;
  background: none;
}
.left-list{
  width: 320px;
  background-color: #363e47;
  height: 100%;
  float: left;
}
.center-list{
  width: calc(100% - 361px);
  background-color: #f2f7f7;
  height: 100%;
  float: left;
}
.right-msg{
  border-left: 1px solid #e3e7e7;
  width: 360px;
  background-color: #ffffff;
  height: 100%;
  float: left;
}
.head-portrait-top{
  height: 170px;
  padding-top: 30px;
  text-align: center;
}
.search-top{
  height: 51px;
  padding-top: 15px;
  border-bottom: 2px solid #303841;
}
.rec-search {
  color: #a5b5c1;
  width: 235px;
  height: 36px;
  background-color: #303841;
  border-radius: 13px;
  margin: 0 15px;
  float: left;
  font-size: 18px;
}
.cir-btn-add {
  width: 36px;
  height: 36px;
  text-align: center;
  line-height: 36px;
  border-radius: 18px;
  background-color: #303841;
  float: left;
  color: #a5b5c1;
}
.contact-list{
  height: calc(100% - 70px);
  overflow-y: auto;
}
.list-item{
  padding: 10px 0;
  height: 60px;
  margin: 0 15px;
}
.head-portrait{
  padding-top: 10px;
  float: left;
  height: 50px;
  width: 60px;
}
.msg-contact{
  color: #d6dce1;
  float: left;
  width: calc(100% - 150px);
  height: 60px;
}
.name-top{
  height: 40px;
  line-height: 50px;
  font-size: 18px;
  color: #d6dce1;
}
.voice-bottom{
  height: 20px;
  font-size: 12px;
}
.msg-time{
  color: #808080;
  float: left;
  width: 90px;
  height: 60px;
  line-height: 60px;
  text-align: right;
}
.title-top{
  height: 51px;
  padding-top: 15px;
  border-bottom: 2px solid #e3e7e7;
}
.title-edit{
  float: left;
  margin-left: 20px;
  width: calc(100% - 80px);
  height: 36px;
  line-height: 36px;
  color: #303841;
  font-size: 20px;
  font-family: PingFang-SC-Medium!important;
}
.user-add-right{
  padding-top: 4px;
  width: 40px;
  height: 40px;
  float: right;
  margin-right: 20px;
  text-align: right;
}
.window-center{
  height: calc(100% - 158px);
  overflow-y: auto;
}
.time-show{
  color: #cccccc;
  height: 20px;
  line-height: 20px;
  width: 130px;
  border-radius: 4px;
  font-size: 10px;
  /*margin: auto;*/
  text-align: center;
}
.chat-item{
  height: 60px;
  margin: 0 20px;
}
.img-left{
  width: 60px;
  padding-top: 5px;
  height: 55px;
  float: left;
}
.img-left1{
  width: 60px;
  padding-top: 5px;
  height: 55px;
  float: right;
}
.voice-right{
  width: 160px;
  padding-top: 10px;
  height: 40px;
  float: left;
  /*background-color: #7ebbfc;*/
}
.voice-right1{
  width: 160px;
  padding-top: 10px;
  height: 40px;
  float: right;
  /*background-color: #7ebbfc;*/
}
.no-read{
  width: 10px;
  height: 10px;
  background-color: #f35d5d;
  border-radius: 5px;
  margin-top: 15px;
}
.left-voice-content{
  background-color: white;
  border-radius: 10px;
  height: 40px;
  line-height: 40px;
  float: left;
}
.left-voice-content img{
  vertical-align: middle;
  margin-left: 10px;
}
.right-voice-content{
  background-color: #55d48b;
  border-radius: 10px;
  height: 40px;
  line-height: 40px;
  text-align: right;
  float: right;
  margin-right: 10px;
}
.right-voice-content img{
  vertical-align: middle;
  margin-right: 10px;
}
.msg-send{
  height: 90px;
  background-color: white;
}
.area-text{
  margin-top: 25px;
  font-size: 18px;
  height: 40px;
  float: left;
  margin-left: 20px;
  width: calc(100% - 170px);
}
.send-btn-chat{
  margin-top: 25px;
  font-family: PingFang-SC-Medium!important;
  font-size: 20px;
  width: 130px;
  height: 40px;
  line-height: 40px;
  color: white;
  text-align: center;
  background-color: #55d48b;
  border-radius: 10px;
  float: right;
  margin-right: 20px;
  cursor: pointer;
}
.msg-list{
  height: 40px;
  font-size: 14px;
  color: #99a8b4;
}
.right-text{
  display: block;
  overflow: hidden;
  word-break: keep-all;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>



// WEBPACK FOOTER //
// src/components/datamanagement/deviceComponents/chatDevice.vue